import styled from 'styled-components';

export const Wrapper = styled.div`
	width: 100%;
`;

export const ParticipantsGrid = styled.div`
	max-height: 400px;
	border: 1px solid ${({ theme }) => theme.colors.transparent.light10};
	border-radius: 5px;
	overflow-y: auto;
`;

export const ParticipantsRow = styled.div`
	display: flex;
	border-bottom: 1px solid ${({ theme }) => theme.colors.transparent.light10};

	&:last-child {
		border-bottom: 0;
	}
`;

export const ParticipantNumber = styled.div`
	padding: 6px 8px;
	font-size: 14px;
	line-height: 19px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.subtitle};
	border-right: 1px solid ${({ theme }) => theme.colors.transparent.light10};
	width: 32px;
`;

export const ParticipantId = styled.div`
	padding: 6px 8px;
	font-size: 14px;
	line-height: 19px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.subtitle};
`;
